import s from "./AudioPlayer.module.css";

type AudioPlayerProps = {
  url: string;
  downloadIsAvailable?: boolean;
  filepath?: string;
  onAudioComplete?: () => void;
  onError?: () => void;
};

const AudioPlayer = ({
  url,
  downloadIsAvailable = true,
  filepath,
  onAudioComplete,
  onError,
}: AudioPlayerProps) => {
  return (
    <div className={s.container}>
      <audio
        className={s.audio}
        controls
        src={url}
        onEnded={onAudioComplete}
        onError={onError}
      />
      {downloadIsAvailable && (
        <a className={s.downloadLink} href={url} download={filepath || true}>
          Download
        </a>
      )}
    </div>
  );
};

export default AudioPlayer;
